import './CaseStudies.css';

const CASE_STUDIES = [
  {
    company: 'FinServe Group',
    industry: 'Financial Services',
    challenge: 'Receiving 5,000+ applications per month with a 12-person recruiting team, leading to a 45-day time-to-hire and high candidate drop-off.',
    solution: 'Implemented VERDICT\'s AI Resume Parsing and Assessment Engine to auto-screen and test candidates before human recruiter review.',
    results: [
      { metric: '45%', label: 'Reduction in Time-to-Hire' },
      { metric: '10k+', label: 'Hours Saved Annually' },
      { metric: '92%', label: 'Candidate Satisfaction' }
    ]
  },
  {
    company: 'Aiprus Software',
    industry: 'Technology',
    challenge: 'Inconsistent technical screening across different engineering managers resulted in biased hiring and poor quality of hires.',
    solution: 'Deployed VERDICT\'s role-specific competency frameworks and standardized coding environments with blind evaluation modes.',
    results: [
      { metric: '60%', label: 'Increase in Offer Acceptance' },
      { metric: '0', label: 'Bias Complaints' },
      { metric: '3x', label: 'Pipeline Velocity' }
    ]
  }
];

export default function CaseStudies() {
  return (
    <section id="casestudies" className="section-divider">
      <div className="section-wrap">
        <span className="eyebrow eyebrow--green">Success Stories</span>
        <h2 className="sec-title">Real challenges. Real results.</h2>
        <p className="sec-sub" style={{ marginBottom: '3rem' }}>
          See how leading organizations use VERDICT to transform their hiring workflows from end to end.
        </p>

        <div className="cs-grid">
          {CASE_STUDIES.map(cs => (
            <div key={cs.company} className="cs-card">
              <div className="cs-header">
                <h3>{cs.company}</h3>
                <span className="cs-industry">{cs.industry}</span>
              </div>
              
              <div className="cs-body">
                <div className="cs-block">
                  <h4 className="cs-label text-red">Challenge</h4>
                  <p>{cs.challenge}</p>
                </div>
                <div className="cs-block">
                  <h4 className="cs-label text-purple">Solution</h4>
                  <p>{cs.solution}</p>
                </div>
              </div>

              <div className="cs-results">
                {cs.results.map(r => (
                  <div key={r.label} className="cs-result-item">
                    <div className="csr-metric">{r.metric}</div>
                    <div className="csr-label">{r.label}</div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}